import { useCallback, type FunctionComponent, type ReactElement } from 'react';
import React from 'react';

import { GameButtonWithTooltip } from '@pp/core/src/components/game/gameButton/gameButton';
import { Icons } from '@pp/core/src/components/icons/iconNames';

import { Bets } from '../../../config';
import { useGameDispatch } from '../../../store/GameStore';
import { useBetStepperSlice } from '../../../store/slices/betStepper/selectors';
import { betStepperActions } from '../../../store/slices/betStepper/slice';
import { useBetStepperDisabled } from '../../gameGrid/hooks';

interface UndoControlConnectedProps {
  betCode: Bets;
}

export const UndoControlConnected: FunctionComponent<UndoControlConnectedProps> = ({ betCode }): ReactElement => {
  const dispatch = useGameDispatch();
  const betInputStack = useBetStepperSlice.getBetInputStack(betCode);
  const betStepperDisabled = useBetStepperDisabled(betCode);
  const isDisabled = betInputStack.length === 0 || betStepperDisabled;

  const handleUndoClick = useCallback(() => {
    dispatch(betStepperActions.undoBetInput(betCode));
  }, [dispatch, betCode]);
  return (
    <GameButtonWithTooltip
      icon={Icons.Undo}
      onClick={handleUndoClick}
      grow
      disabled={isDisabled}
      tooltipOptions={{
        text: 'UNDO',
        disabled: isDisabled,
      }}
    />
  );
};
